"use strict";

exports.__esModule = true;
exports.DELETE_BASE_FAILURE = exports.CREATE_BASE_FAILURE = void 0;
const CREATE_BASE_FAILURE = exports.CREATE_BASE_FAILURE = 'CREATE_BASE_FAILURE';
const DELETE_BASE_FAILURE = exports.DELETE_BASE_FAILURE = 'DELETE_BASE_FAILURE';